import { CoreModule, LicenseManager } from "dynamsoft-barcode-reader-bundle";

CoreModule.engineResourcePaths.rootDirectory = "/dynamsoft-resources/";
LicenseManager.initLicense(process.env.REACT_APP_DYNAMSOFT_LICENCE);
CoreModule.loadWasm();
